import { ApiUrl } from '@common/enums';
import { OptionalItemsResponse } from '@common/models/optional-items-response';
import { easyEstimatorApi } from '@ee-api/easyEstimatorService';
import { CommonProductQueryParams } from '@ee-api/queryParams';

const optionalItemsService = easyEstimatorApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchOptionalItems: builder.query<OptionalItemsResponse, CommonProductQueryParams>({
            query: ({ params }) => ({
                url: ApiUrl.OPTIONAL_ITEMS,
                method: 'GET',
                params,
            }),
        }),
    }),
});

export const { useFetchOptionalItemsQuery, useLazyFetchOptionalItemsQuery } = optionalItemsService;
